export default __webpack_public_path__ + "static/media/git.6d85bc9b.png";